import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["defaultText", "copiedText"]
  static values = { text: String }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      // Show success feedback
      this.defaultTextTarget.classList.add("hidden")
      this.copiedTextTarget.classList.remove("hidden")

      // Reset after 2 seconds
      setTimeout(() => {
        this.defaultTextTarget.classList.remove("hidden")
        this.copiedTextTarget.classList.add("hidden")
      }, 2000)
    }).catch(err => {
      console.error('Failed to copy:', err)
    })
  }
}

